import React, { useEffect, useRef, useState } from "react";
import s1 from "../../assets/personal/summit/s1.jpg";
import s1a from "../../assets/personal/summit/s1a.jpg";
import s1b from "../../assets/personal/summit/s1b.jpg";
import s2 from "../../assets/personal/summit/s2.jpg";
import s2a from "../../assets/personal/summit/s2a.jpg";
import s3 from "../../assets/personal/summit/s3.jpg";
import s4 from "../../assets/personal/summit/s4.jpg";
import s4a from "../../assets/personal/summit/s4a.jpg";
import s5 from "../../assets/personal/summit/s5.jpg";
import s5a from "../../assets/personal/summit/s5a.jpg";
import s6 from "../../assets/personal/summit/s6.jpg";
import s7 from "../../assets/personal/summit/s7.jpg";
import s8 from "../../assets/personal/summit/s8.jpg";

const summitImages = [s1, s1a, s1b, s2, s2a, s3, s4, s4a, s5, s5a, s6, s7, s8];

export default function SummitCarousel() {
  const containerRef = useRef(null);
  const [setIsTransitioning] = useState(false);
  const scrollRef = useRef(0);
  const animationRef = useRef(null);

  // Smooth auto scroll
  useEffect(() => {
    const scrollSpeed = 0.5; // pixels per frame

    const step = () => {
      if (containerRef.current) {
        scrollRef.current += scrollSpeed;
        const totalWidth = containerRef.current.scrollWidth / 2;
        if (scrollRef.current >= totalWidth) scrollRef.current = 0;
        containerRef.current.style.transform = `translateX(-${scrollRef.current}px)`;
      }
      animationRef.current = requestAnimationFrame(step);
    };

    animationRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animationRef.current);
  }, []);

  // Smooth scroll on arrow click
  const smoothScroll = (distance) => {
    if (!containerRef.current) return;
    setIsTransitioning(true);

    const start = scrollRef.current;
    // const end = start + distance;
    const duration = 400; // ms
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = 0.5 - Math.cos(progress * Math.PI) / 2; // smooth easing
      scrollRef.current = start + (distance * ease);
      const totalWidth = containerRef.current.scrollWidth / 2;
      if (scrollRef.current >= totalWidth) scrollRef.current -= totalWidth;
      if (scrollRef.current < 0) scrollRef.current += totalWidth;
      containerRef.current.style.transform = `translateX(-${scrollRef.current}px)`;
      if (progress < 1) requestAnimationFrame(animate);
      else setIsTransitioning(false);
    };

    requestAnimationFrame(animate);
  };

  const scrollLeft = () => smoothScroll(-containerRef.current.offsetWidth / 3);
  const scrollRight = () => smoothScroll(containerRef.current.offsetWidth / 3);

  return (
    <section className="py-16 px-2 md:px-8 relative">
      <div className="w-full mx-auto relative overflow-hidden rounded-2xl shadow-lg bg-gradient-to-b from-black/10 to-black/20">

        {/* Overlay Heading */}
        <div className="absolute top-0 inset-x-0 w-full bg-black/60 px-6 py-5 text-center z-20 rounded-b-lg backdrop-blur-sm">
          <h1 className="text-white text-3xl md:text-4xl font-bold mj-heading">
            Chasing Peaks, Building Character
          </h1>
          <p className="text-gray-300 italic mt-2 text-base md:text-lg mj-subheading">
            A personal path shaped by mountains, miles, and moments that taught purpose. 
            This page shares the most meaningful stops on that road.
          </p>
        </div>

        {/* Slides */}
        <div
          ref={containerRef}
          className="flex flex-nowrap gap-4 transition-transform duration-500 ease-out"
          style={{ willChange: "transform" }}
        >
          {summitImages.concat(summitImages).map((img, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-1/2 sm:w-1/3 md:w-1/4 cursor-pointer transform transition-transform duration-300 hover:scale-105 hover:shadow-2xl"
            >
              <img
                src={img}
                alt={`summit-${i}`}
                className="w-full h-72 sm:h-96 md:h-[40rem] object-cover rounded-lg"
              />
            </div>
          ))}
        </div>

        {/* Arrows */}
        <button
          onClick={scrollLeft}
          className="absolute left-0 top-0 h-full w-12 md:w-16 bg-gradient-to-r from-black/50 to-transparent text-white text-2xl flex items-center justify-center hover:from-black/70 transition z-10"
        >
          &lt;
        </button>
        <button
          onClick={scrollRight}
          className="absolute right-0 top-0 h-full w-12 md:w-16 bg-gradient-to-l from-black/50 to-transparent text-white text-2xl flex items-center justify-center hover:from-black/70 transition z-10"
        >
          &gt;
        </button>
      </div>
    </section>
  );
}
